export const INSERT_EQUIPMENTS = "INSERT_EQUIPMENTS";
export const INSERT_EQUIPMENTS_SUCCESS = "INSERT_EQUIPMENTS_SUCCESS";
export const LOAD_ALL_EQUIPMENTS = "LOAD_ALL_EQUIPMENTS";
export const LOAD_ALL_EQUIPMENTS_SUCCESS = "LOAD_ALL_EQUIPMENTS_SUCCESS";
export const EQUIPMENTS_API_ERROR = "EQUIPMENTS_API_ERROR";
